

























































import { Component, Vue, Prop  } from 'vue-property-decorator'
import  NoData from '@/components/NoData'
const echarts = require('echarts')
@Component({
  name: 'Tenthousand',
  components: {NoData },
 filters:{
   dateFilter: (value: string) => {
     if(!value){
       return 
     }
   
     return value.toString().indexOf('-') > -1? (value.split('-')[0]+'年'+value.split('-')[1]+'月'): (value+'年')
   }
 }
})
export default class Tenthousand extends Vue {
  @Prop() data: any
  @Prop() index: any
  @Prop() DateObj: any
  private init() {
    const echartsData: any = []
    
    if( this.data.outputList.length==0){
      return
    }
    this.data.outputList.forEach((item: any) => {
      echartsData.push([item.statDate, Number(item.dataValue)])
    })
    const main = document.getElementById('Tenthousandone')
    // 基于准备好的dom，初始化echarts实例
    const myChart: any = echarts.init(main as HTMLDivElement)
    // 指定图表的配置项和数据
    const option = {
      color: ['#44f0ff'],
      textStyle: {
        color: '#999999',
      },
      tooltip: {},
      grid: {
       	left: '20',
        top: '10',
        right: '20',
        bottom: '0',
        containLabel: true
      },
      // legend: {
      //   data: ['销量'],
      // },
      // barCategoryGap:'65%',
      yAxis: {
        gridIndex: 0,
        type: 'value',
        min: 0,
        axisLine:{
            lineStyle:{
            color:'#ededff',
            width:1
            }
        },
        axisTick:{
            show:false
        },
        axisLabel: {
            color: '#999',
            fontSize: 12,
            formatter: '{value}'
        },
      },
      xAxis: {
        gridIndex: 0,
        type: 'category',
        axisPointer: {
            type: 'shadow'
        },
        axisLine:{
            lineStyle:{
            color:'#ededff',
            width:1
            }
        },
        axisTick:{
            show:false
        },
        axisLabel: {
            color: '#999',
            fontSize: 12
        },
      },
      series: [
        {
            name: '万元工业总产值能耗',
            type: 'bar',
            barWidth : 20,//柱图宽度
            itemStyle: {
              normal: {
              color: '#4680f5',
              borderRadius: 5,
              label:{
                fontSize:9,
                show:false,
                position: 'top'
              }
              }
            },   
            data: echartsData
          },{
            name: '综合能源消费量',
            type: 'line',
            barWidth: '30%',
            smooth: true,
            showSymbol: true,
            symbol: 'emptyCircle', //设定为实心点
            symbolSize: 8, //设定实心点的大小
            tooltip:{
              show: false
            },
            itemStyle: {
                normal: {
                    color: '#ff4747', //改变折线点的颜色
                    lineStyle: {
                        color: '#ff4747', //改变折线颜色
                        width:2
                    },
                    label: {
                        show: false,
                        position: 'top',
                        textStyle: {
                            color: '#0FDBA2',
                        },
                        formatter: '{value}'
                    },
                },
            },
            data: echartsData
        }
      ],
    }
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option)
  }
  ReloadFun(){
    setTimeout(() => {
      this.init()
    }, 0)
  }
  textType(text:any){
      if(text == null) return '-'
      if(text > 0 ) return '+'+text
      if(text < 0 ) return text
      if(text == 0) return text
  }
  colorType(text:any){
      if(text > 0 ) return 'negative'
      if(text < 0 ) return 'positive'
      if(text == 0) return ''
  }
  created() {
    setTimeout(() => {
      this.init()
    }, 0)
  }
}
